import { APIError } from '../api/errors/APIError';
import { usePartners } from '../api/hooks/partners';
import { useAPIQuery } from '../api/useAPIProvider';

export interface CustomerOrgTree {
  customerId: string;
  customerName: string;
}

export interface MspOrgTree {
  mspId: string;
  mspName: string;
  customers: CustomerOrgTree[];
}

export interface OrgTree {
  msps: MspOrgTree[];
}

export const useBuildOrgTree = () => {
  const [msps] = usePartners();

  return useAPIQuery(['orgTree'], async client => {
    return await Promise.all(
      msps.map(async msp => {
        const customerResponse = await client.companies.getCompanies({ params: { partnerId: msp.id } });
        if (customerResponse.status !== 200) throw APIError.fromResponse(customerResponse);

        return {
          mspId: msp.id,
          mspName: msp.name,
          customers: customerResponse.body.items.map(customer => {
            return {
              customerId: customer.id,
              customerName: customer.name
            };
          })
        };
      })
    );
  });
};
